<template>
	<sf-modal-layout :show="taskScriptModal" size="xl" :title="getMessage_('SWCC000325')" :closeModal="closeModal">
		<div :style="{ width: '50%', display: 'flex', justifyContent: 'flex-start' }">
			<h3>
				{{ taskName }}
			</h3>
		</div>
		<cm-editor />
		<template v-slot:footer>
			<sf-button line :onClick="closeModal">{{ getMessage_('SWCC000113') }}</sf-button>
			<sf-button v-if="isButton_(scrId, 'AD')" :onClick="saveAction">{{ getMessage_('SWCC000278') }}</sf-button>
		</template>
	</sf-modal-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/TaskManagement/store/helpers';
import CmEditor from './CmEditor';
import { utils } from '@sfaas/util';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { CmEditor },
	data() {
		return {};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		taskName() {
			return utils.isUndefined(this.scriptParams.taskId) || utils.$sf_isNull(this.scriptParams.taskId)
				? ''
				: `${this.scriptParams.taskId}_v${this.scriptParams.version}`;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		saveAction() {
			const updatedScript = this.codemirror.doc.getValue();

			this.$sf_showMessage({
				type: 'confirm',
				icon: 'confirm',
				title: this.getMessage_('SWCC000553'), //수정하시겠습니까?
				buttons: [{ title: this.getMessage_('SWCC000279'), clickFn: () => this.save(updatedScript) }] //수정
			});
		},
		save(updatedScript) {
			this.DEFAULT_ASSIGN({ key: 'scriptParams', value: { ...this.scriptParams, compileCd: updatedScript } });
			this.$sf_toggleLoading(true);
			this.updateTaskScript_({
				plantCd: this.user.plantCd,
				taskId: this.scriptParams.taskId,
				version: this.scriptParams.version,
				task: this.scriptParams
			})
				.then(this.fetchTasks_({ plantCd: this.user.plantCd, urlSearchParams: this.urlSearchParams_ }))
				.then(this.closeModal())
				.then(header => {
					this.$sf_toast({
						...this.$sf_setToastOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => this.$sf_toggleLoading(false));
		},
		closeModal() {
			this.DEFAULT_ASSIGN({ key: 'scriptParams', value: {} });
			this.DEFAULT_ASSIGN({ key: 'taskScriptModal', value: false });
		}
	}
};
</script>

<style></style>
